import { useSelector } from "react-redux";

type KeycloakState = {
    logged: true;
    userRoles: string[];
    userName: string;
    token: string;
    location: any;
    sub: string;
    name: string;
    email: string;
};

export const useKeycloakSelector = (): KeycloakState => {
    return useSelector((state: any) => state.keycloak);
};
